<ui-dialog size="small" (closing)="onClose()" [open]="openDialog" header="{{ headerTitle }}">
    <p>{{ 'time-off-v3.youAreAboutToDenyNamesTimeOffRequest' | translate: { name } }}</p>
    <p>{{ timeOffDates }}</p>
    <p class="font-bold" *ngIf="extraText">{{ extraText }}</p>
    <form class="app-grid" #form="ngForm">
        <mat-form-field class="columns-12 no-helpers">
            <textarea
                matInput
                rows="5"
                [maxlength]="maxlength"
                name="timeOffComment"
                placeholder="{{ 'time-off-v3.provideAReasonForDenyingTheRequestOptional' | translate }}"
                [(ngModel)]="comment"
                #commentModel="ngModel"
            ></textarea>
        </mat-form-field>
    </form>
    <div class="text-align-right">{{ 'time-off-v3.characterLimitIsMaxlength' | translate: { max: maxlength } }}</div>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="onClose()">{{ 'time-off-v3.cancel' | translate }}</ui-button>
        <ui-button type="primary" (click)="onConfirm()">{{ primaryButtonLabel }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>
